import React from 'react'
import { FormGroup, Input, Label } from 'reactstrap'

/**
 * 
 * @param {import('../types').FormV2FieldProps} param0 
 */
const RadioV2Field = ({
    value,
    onChange,
    onBlur,
    onFocus,
    isRequired,
    isDisabled,
    errorMessage,
    classes,
    styles,
    lang,
    aria,
    options,
    placeholder,
    id,
    name,
    valid,
    hasError,
    field,
}) => {
    return (
        <div role='presentation' className={`formV2-field-input-radio-wrapper ${field?.config?.horizontalRadio ? 'horizontal' : ''} ${classes?.container || ''}`} style={styles?.container}>
            {options?.map(opt => {

                return <FormGroup
                    check
                    id={id + opt.value + 'group'}
                    key={id + opt.value}
                    disabled={isDisabled}
                    style={styles?.field}
                    className={`formV2-field-input-radio ${classes?.field || ''}`}
                    {...aria || {}}
                >
                    <Input
                        type='radio'
                        id={id + opt.value}
                        name={name}
                        value={opt.value}
                        checked={value === opt.value}
                        onChange={e => onChange?.(e.target.value)}
                        onBlur={onBlur}
                        onFocus={onFocus}
                        required={isRequired}
                        disabled={isDisabled}
                        invalid={hasError}
                        valid={valid}
                    />
                    <Label
                        check
                        htmlFor={id + opt.value}
                        id={id + opt.value + 'label'}
                    >
                        {opt.label ? opt.label.translate(lang) : ''}
                    </Label>
                </FormGroup>
            })}
        </div>
    )
}

export default RadioV2Field